import { ReactNode } from 'react';

import { StyledSideContainer } from './styles';

export const SideContainer = ({ children }: { children: ReactNode }) => {
  return <StyledSideContainer>{children}</StyledSideContainer>;
};
